import { BaseLink, Picture, Typography } from '@which/seatbelt'
import { dynamicGa4DataLayerPush } from '@which/shared'

import classnames from 'classnames'

import type { RecommendedContentType } from '../../models'
import styles from './RecommendationsImageLinksLayout.module.scss'

type LinkWithImageProps = {
  whichId: string
  sectionTitle: string
  recommendation: RecommendedContentType
  index: number
  position?: string
}

const LinkWithImage = ({
  whichId,
  sectionTitle,
  recommendation,
  index,
  position,
}: LinkWithImageProps) => {
  const title = recommendation.__typename == 'RecommendedArticle' ? recommendation.title : ''
  const { href, image = '' } = recommendation
  const analyticsInfo = position && `r4u-${position}-link-${index + 1}`

  return (
    <li key={`${title}-${index}`} className={styles.multiLinkListItem}>
      <BaseLink
        appearance="secondary"
        aria-label={title}
        className={classnames('sb-link-secondary', styles.imageTextWrapper)}
        data-testid="navigation-link"
        data-which-id={analyticsInfo}
        href={href}
        onClick={() => {
          dynamicGa4DataLayerPush({
            event: 'notification_ab_test',
            item_text: analyticsInfo ?? title,
            item_parent_text: sectionTitle,
            item_group: whichId,
          })
        }}
      >
        <Picture
          aspectRatioMain="four-to-three"
          aspectRatioSm="one-to-one"
          className={styles.image}
          data-testid="navigation-link-image"
          src={image}
        />
        <Typography
          className={styles.articleTitle}
          tag="span"
          textStyle="sb-text-interface-body-default-regular"
        >
          <span className="sb-link-animation-wrapper">{title}</span>
        </Typography>
      </BaseLink>
    </li>
  )
}

type RecommendationsImageLinksLayoutProps = {
  recommendations: RecommendedContentType[]
  title: string
  whichId: string
  modelId: string
  position?: string
}

export const RecommendationsImageLinksLayout = ({
  recommendations,
  title,
  whichId,
  modelId,
  position,
}: RecommendationsImageLinksLayoutProps) => (
  <section className={styles.recommendationsImageLinks}>
    <Typography
      tag="h2"
      textStyle="sb-text-heading-small"
      className="sb-padding-bottom-3"
      data-testid="multi-link-title"
      data-parent-id={modelId}
    >
      {title}
    </Typography>

    <ul className={styles.multiLinkList}>
      {recommendations.map((recommendation, index) => (
        <LinkWithImage
          whichId={whichId}
          sectionTitle={title}
          recommendation={recommendation}
          index={index}
          position={position}
          key={index}
        />
      ))}
    </ul>
  </section>
)
